
import { Component, OnInit } from "@angular/core";
import { ConsultaBitacoraInputService } from "../../servicios/bitacoras.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { ConsultaBitacora, ConsultaBitacoraInput } from "../../entidades/entidades";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: "app-consulta-bitacora-grid",
    templateUrl: "./consulta-bitacora-grid.component.html",
    styleUrls: ["./consulta-bitacora-grid.component.css"],
})

export class ConsultaBitacoraGridComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    consultaBitacora: any;
    itemsMenu: MenuItem[];
    columnasTabla: any[];
    buscaBitacoraForm: FormGroup;
    buscando: boolean = false;
    consultaBitacoraInput: ConsultaBitacoraInput;

    public fechaIniSeleccionada: Date;
    public fechaFinSeleccionada: Date;
    public cuentaSeleccionada: number;

    constructor(
        private consultaBitacoraService: ConsultaBitacoraInputService,
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.buscaBitacoraForm = this.formBuilder.group({
            BitacoraDesde: [undefined],
            BitacoraHasta: [undefined],
            Cuenta: [undefined],
        });

        let date = new Date()

        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        let dateDefault;
        if (month < 10)
            dateDefault = `${year}-0${month}-${day}`;
        else
            dateDefault = `${year}-${month}-${day}`;

        if (day < 10)
            dateDefault = `${year}-${month}-0${day}`;
        else
            dateDefault = `${year}-${month}-${day}`;
        this.fechaIniSeleccionada = dateDefault;
        this.fechaFinSeleccionada = dateDefault;

        // ===============================================================
        //Opciones de la tabla
        // ===============================================================
        // prettier-ignore
        this.columnasTabla = [
            { field: "cuentaAgua", header: "Contrato", ordenar: true, styleHeader: "width: 100px;", },
            { field: "nombreCompleto", header: "Cliente", ordenar: true, styleHeader: "width: 250px;", },
            { field: "domicilio", header: "Domicilio", ordenar: true, styleHeader: "width: 300px;", },
            { field: "colonia", header: "Colonia", ordenar: true, styleHeader: "width: 200px;", },
            { field: "ruta", header: "Ruta", ordenar: true, styleHeader: "width: 50px;", },
            { field: "tipoServicio", header: "Tipo de Servicio", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoUso", header: "Tipo de Uso", ordenar: true, styleHeader: "width: 100px;", },
            { field: "fechaAlta", header: "Fecha de Alta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "numeroMedidor", header: "Numero de Medidor", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoBloqueo", header: "Tipo de Bloqueo", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoPeriodo", header: "Tipo de Periodo", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoToma", header: "Tipo de Toma", ordenar: true, styleHeader: "width: 100px;", },
            { field: "cp", header: "C.P.", ordenar: true, styleHeader: "width: 75px;", },
            { field: "rfc", header: "RFC", ordenar: true, styleHeader: "width: 150px;", },
            { field: "base", header: "Base", ordenar: true, styleHeader: "width: 100px;", },
            { field: "total", header: "Total", ordenar: true, styleHeader: "width: 100px;", },
            { field: "manejo", header: "Manejo", ordenar: true, styleHeader: "width: 100px;", },
            { field: "drenaje", header: "Drenaje", ordenar: true, styleHeader: "width: 100px;", },
            { field: "importe", header: "Importe", ordenar: true, styleHeader: "width: 100px;", },
            { field: "recargos", header: "Recargos", ordenar: true, styleHeader: "width: 100px;", },
            { field: "redondeo", header: "Redondeo", ordenar: true, styleHeader: "width: 100px;", },
            { field: "descuento", header: "Descuento", ordenar: true, styleHeader: "width: 100px;", },
            { field: "ivaTotal", header: "Iva Total", ordenar: true, styleHeader: "width: 100px;", },
            { field: "anioDesde", header: "Año Desde", ordenar: true, styleHeader: "width: 100px;", },
            { field: "anioHasta", header: "Año Hasta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "actualizacion", header: "Actualización", ordenar: true, styleHeader: "width: 100px;", },
            { field: "calculoMulta", header: "Calculo Multa", ordenar: true, styleHeader: "width: 100px;", },
            { field: "periodoDesde", header: "Periodo Desde", ordenar: true, styleHeader: "width: 100px;", },
            { field: "periodoHasta", header: "Periodo Hasta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "calculoGastos", header: "Calculo Gastos", ordenar: true, styleHeader: "width: 100px;", },
            { field: "estatusCuenta", header: "Estatus Cuenta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "gastosVigente", header: "Gastos Vigente", ordenar: true, styleHeader: "width: 100px;", },
            { field: "multasVigente", header: "Multas Vigente", ordenar: true, styleHeader: "width: 100px;", },
            { field: "claveCatastral", header: "Clave Catastral", ordenar: true, styleHeader: "width: 100px;", },
            { field: "redondeoRezago", header: "Redondeo Rezago", ordenar: true, styleHeader: "width: 100px;", },
            { field: "totalMultasGastos", header: "Total Multas Gastos", ordenar: true, styleHeader: "width: 100px;", },
            { field: "estatusFiscalizacion", header: "Estatus Fiscalizacion", ordenar: true, styleHeader: "width: 200px;", },
            { field: "tipoGrupoVulnerable", header: "Tipo Campaña", ordenar: true, styleHeader: "width: 200px;", },
            { field: "ultimoBimFactuarado", header: "Ultimo Bim Factuarado", ordenar: true, styleHeader: "width: 100px;", },

        ];
    }

    async limpiar() {
        this.consultaBitacora = null;
        this.cuentaSeleccionada = null;
        this.fechaFinSeleccionada = null;
        this.fechaIniSeleccionada = null;
    }

    async buscar() {
        if (this.buscando) {
            return;
        }

        try {
            this.buscando = true;
            this.consultaBitacoraInput = new ConsultaBitacoraInput;
            this.consultaBitacoraInput.cuentaAgua = this.cuentaSeleccionada;
            this.consultaBitacoraInput.fechaFin = this.fechaFinSeleccionada;
            this.consultaBitacoraInput.fechaIn = this.fechaIniSeleccionada;

            let valores = new ConsultaBitacoraInput();
            valores = this.buscaBitacoraForm.value;
            if (this.consultaBitacoraInput.cuentaAgua == null &&
                this.consultaBitacoraInput.fechaIn == null) {
                console.log("entro a validacion ");
                throw new Error("Debe capturar por lo menos un criterio de busqueda.");
            }
            if (this.consultaBitacoraInput.fechaIn == null || this.consultaBitacoraInput.fechaFin == null) {
                throw new Error("Ingrese un rango de fechas.")
            }
            else if (this.consultaBitacoraInput.fechaIn <= this.consultaBitacoraInput.fechaFin) {
                await this.getBitacora(this.consultaBitacoraInput);
            } else {
                throw new Error("La fecha de límite inferior es mayor que la fecha del límite superior.")
            }

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            this.buscando = false;
        } finally {
            console.log("Paso por getAllPadronAguaGenerales");
            this.buscando = false;
        }

    }

    async getBitacora(consultaBitacoraInput: ConsultaBitacoraInput) {
        try {
            const datoRetorno = await this.consultaBitacoraService
                .getConsultaBitacora(consultaBitacoraInput)
                .toPromise();
            this.buscando = false;
            this.consultaBitacora = datoRetorno;
            if (!this.consultaBitacora[0]) {
                this.muestraMensaje.error("No se encontro ningún registro.", "top", "center");
                this.limpiar();
            }

            if (this.consultaBitacora) {
                for (let i = 0; i < this.consultaBitacora.length; i++) {
                    if (this.consultaBitacora[i].fechaAlta) {
                        let aux = this.consultaBitacora[i].fechaAlta;
                        let fechaAlta = aux.split("-");
                        let fechaDia = fechaAlta[2].split("T");
                        let fechaFinalBitacora = fechaDia[0] + "/" + fechaAlta[0] + "/" + fechaAlta[1];
                        datoRetorno[i].fechaAlta = fechaFinalBitacora;
                    }
                    if (this.consultaBitacora[i].periodoDesde) {
                        let aux = this.consultaBitacora[i].periodoDesde;
                        let periodoDesde = aux.split("-");
                        let periodoFinalBitacora = "BIM-" + periodoDesde[1] + "-" + periodoDesde[0];
                        datoRetorno[i].periodoDesde = periodoFinalBitacora;
                    }
                    if (this.consultaBitacora[i].periodoHasta) {
                        let aux = this.consultaBitacora[i].periodoHasta;
                        let periodoHasta = aux.split("-");
                        let periodoFinalBitacora = "BIM-" + periodoHasta[1] + "-" + periodoHasta[0];
                        datoRetorno[i].periodoHasta = periodoFinalBitacora;
                    }
                    if (this.consultaBitacora[i].ultimoBimFactuarado) {
                        let aux = this.consultaBitacora[i].ultimoBimFactuarado;
                        let ultimoBimFactuarado = aux.split(".");
                        let bimFinalBitacora = "BIM-" + ultimoBimFactuarado[1] + "-" + ultimoBimFactuarado[0];
                        datoRetorno[i].ultimoBimFactuarado = bimFinalBitacora;
                    }
                }
            }
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por  getALLpadronAguaGenerales");
        }
    }

    // prettier-ignore
    async getAllConsultaBitacora() {
        try {
            const datoRetorno = await this.consultaBitacoraService.getAll().toPromise();
            this.consultaBitacora = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getAllConsultaBitacora");
        }
    }
}